const IDX = {
  converters: process.env.REACT_APP_ALGOLIA_INDEX_CONVERTERS,
  metals:     process.env.REACT_APP_ALGOLIA_INDEX_METALS,
  trucks:     process.env.REACT_APP_ALGOLIA_INDEX_TRUCKS,
  boards:     process.env.REACT_APP_ALGOLIA_INDEX_BOARDS,
  buyLists:   process.env.REACT_APP_ALGOLIA_INDEX_BUYLIST,
};

export default IDX;
